import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BlockTitle from '@/features/editorial/components/home/modules/blocks/BlockTitle.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import AuthorPreview from '@/features/editorial/components/AuthorPreview.vue';

import { ArticleClickedData, BlockArticle } from '@/features/editorial/types/editorial-types';

import { getHeaderImage } from '@/features/editorial/helpers/editorial-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleList',
  props: {
    blockData: null,
    blockIndex: null,
    moduleIndex: null
  },
  emits: ["articleClicked", "authorClicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'articleClicked', data: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	blockData: { articles: BlockArticle[]; translatables: { title: string } };
	blockIndex: number;
	moduleIndex: number;
};





const articles = computed(() =>
	props.blockData.articles.map(article => ({ ...article, headerImage: getHeaderImage(article) }))
);

function handleArticleClick(article: BlockArticle, index: number) {
	const articleData = {
		slug: article.content.fullPath,
		articleType: article.content.articleType,
		index,
	};

	emits('articleClicked', articleData);
}

function handleAuthorClick(id: string | undefined) {
	emits('authorClicked', id);
}

return { __sfc: true,props, emits, articles, handleArticleClick, handleAuthorClick, BlockTitle, PictureComp, AuthorPreview }
}

})